import $ from '../utils/jquery';

const $tooltipToggles = $( '.tooltip-toggle' );

const getTooltip = ( $toggle ) => {
	const tooltipId = $toggle.attr( 'aria-describedby' );
	return $( `#${tooltipId}` );
};

const show = ( $toggle ) => {
	const $tooltip = getTooltip( $toggle );
	$tooltip.addClass( 'show' );
};

const hide = ( $toggle ) => {
	const $tooltip = getTooltip( $toggle );
	$tooltip.removeClass( 'show' );
};

const toggle = ( $toggle ) => {
	const $tooltip = getTooltip( $toggle );

	if ( $tooltip.hasClass( 'show' ) ) {
		$tooltip.removeClass( 'show' );
	} else {
		$tooltip.addClass( 'show' );
	}
};

const hideAll = () => {
	$tooltipToggles.each( function() {
		hide( $( this ) );
	} );
};

const bind = () => {
	// Hover: show on mouseenter, hide on mouseleave
	$tooltipToggles.on( 'mouseenter', function() {
		show( $( this ) );
	} );

	$tooltipToggles.on( 'mouseleave', function() {
		hide( $( this ) );
	} );

	// Click: toggle
	$tooltipToggles.on( 'click', function( e ) {
		e.preventDefault();
		toggle( $( this ) );
	} );

	// Keyboard: Enter to toggle
	$tooltipToggles.on( 'keydown', function( e ) {
		if ( e.key === 'Enter' || e.keyCode === 13 ) {
			e.preventDefault();
			toggle( $( this ) );
		}
	} );

	// Escape: hide all tooltips
	$( document ).on( 'keydown', function( e ) {
		if ( e.key === 'Escape' || e.keyCode === 27 ) {
			hideAll();
		}
	} );
};

export default () => {
	if ( ! $tooltipToggles.length ) {
		return;
	}

	bind();
};
